export enum EndpointType {
  REST = 'rest'
}
